import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { SSectionTitle, SSectionSlug } from './styles';
function SectionTitle({
  title,
  subTitle = 'OASIS LIVING',
  className = '',
  inverted,
}) {
  return (
    <Row>
      <Col xs="12" className={className}>
        <SSectionSlug>{subTitle}</SSectionSlug>
        <SSectionTitle inverted={inverted}>{title}</SSectionTitle>
      </Col>
    </Row>
  );
}

SectionTitle.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  className: PropTypes.string,
  inverted: PropTypes.bool,
};

export default SectionTitle;
